package com.anjuros.website.redesign.sections.blogarticle

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdCrumb
import com.anjuros.website.redesign.components.jsonString
import com.anjuros.website.redesign.components.rdBreadcrumbJsonLd
import com.anjuros.website.redesign.sections.blog.RdBlogGuide
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL

/** JSON-LD for an article: the blog post with its author and date, and the breadcrumb. */
@Composable
fun articleStructuredData(guide: RdBlogGuide): String {
    val title = LocalText(guide.card.title)
    val url = "$SITE_URL${guide.card.pathToArticle}"
    val author = LocalText(RdText.ABOUT_NAME)
    val breadcrumb = rdBreadcrumbJsonLd(title, guide.card.pathToArticle, listOf(RdCrumb(RdText.BLOG_CRUMB, RdRoute.BLOG)))
    return """
        {"@context":"https://schema.org","@graph":[
         {"@type":"BlogPosting","headline":${jsonString(title)},"url":"$url","mainEntityOfPage":"$url",
          "datePublished":"${guide.published}","image":"$SITE_URL${guide.image.src}",
          "author":{"@type":"Person","name":${jsonString(author)},"url":"$SITE_URL${RdRoute.ABOUT}"},
          "publisher":{"@id":"$SITE_URL/#business"},"isPartOf":{"@id":"$SITE_URL${RdRoute.BLOG}#blog"}},
         $breadcrumb
        ]}
    """.trimIndent()
}
